<script setup lang="ts">
import { HousingSiteResult, HousingFinderInput } from "~/api";
import ApplicationFinderInputs from "./ApplicationFinderInputs.vue";
import ApplicationLocationPreferences from "./ApplicationLocationPreferences.vue";

const props = defineProps<{
  finderInputs: HousingFinderInput | undefined;
  locationsSelected: HousingSiteResult[] | undefined;
  // When true, render the internal layout as a single column so it fits
  // inside narrow containers such as a fixed-width sidebar.
  singleColumn?: boolean;
}>();
</script>
<template>
  <div
    class="ApplicationLocations"
    :class="{ 'single-column': props.singleColumn }"
  >
    <ApplicationFinderInputs
      v-if="finderInputs"
      :finder-inputs="finderInputs"
    />

    <div class="application-location-preferences">
      <div>
        <b>Locations</b>
      </div>
      <ApplicationLocationPreferences
        v-if="locationsSelected"
        :locations-selected="locationsSelected"
        :single-column="props.singleColumn"
        class="locations"
      />
    </div>
  </div>
</template>
<style lang="less">
.ApplicationLocations {
  display: flex;
  gap: 4rem;
  align-items: flex-start;
  font-size: 0.9rem;

  .application-location-preferences {
    min-width: 400px;
    width: 50%;
    max-width: 600px;
  }

  &.single-column {
    flex-direction: column;
    gap: 0.5rem;
    line-height: 1.4;
    color: var(--el-text-color-primary);
    padding-left: 8px;
    .application-location-preferences {
      min-width: 0;
      width: 100%;
      max-width: none;

      > div > b {
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.03em;
        color: var(--el-text-color-secondary);
      }
    }

    > * {
      width: 100%;
      min-width: 0;
    }
  }
}
</style>
